import { BaseConfig } from "../config.interface";
import { Size, Validate } from "../util";

interface IInputTextareaConfig {
    label?: string;
    minlength?: number;
    maxlength?: number;
    autocomplete?: string;
    autoResize?: boolean;
    size: Size | "full";

    validate: Validate;
}
export class InputTextareaConfig extends BaseConfig<IInputTextareaConfig> implements IInputTextareaConfig {
    /**
     * Label of the element.
     */
    label?: string;
    /**
     * Min length of the value.
     */
    minlength?: number;
    /**
     * Max length of the value.
     * @note May be overwritten by a formControl validator
     */
    maxlength?: number;
    /**
     * Browser autocomplete attribute.
     */
    autocomplete?: string;
    /**
     * Size of the input element.
     * @values "small" | "medium" | "large"
     */
    size: Size | "full";
    /**
     * Allow auto resize of the element.
     */
    autoResize?: boolean;
    /**
     * Show validation status already in `pristine` state or after it has been marked as `dirty`.
     */
    validate: Validate;

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         */
        Default: new InputTextareaConfig({
            autoResize: true,
            validate:   "dirty",
            size:       "large",
        }),

        /**
         * Use this config for all description texts in steppers.
         */
        Description: new InputTextareaConfig({
            autoResize: true,
            validate:   "dirty",
            label:      "COMPONENT.DESCRIPTION",
            size:       "large",
            maxlength:  250
        }),

        /**
         * Medium sized description config.
         */
        Medium: new InputTextareaConfig({
            autoResize: false,
            validate:   "dirty",
            label:      "COMPONENT.DESCRIPTION",
            size:       "medium",
            maxlength:  250,
        }),

        /**
         * Medium sized with no label & maxlength config.
         */
        MediumNoLabel: new InputTextareaConfig({
            autoResize: false,
            validate:   "dirty",
            size:       "medium",
        }),

        /**
         * Large sized description config.
         */
        Large: new InputTextareaConfig({
            autoResize: false,
            validate:   "dirty",
            label:      "COMPONENT.DESCRIPTION",
            size:       "large",
        }),
    };

}
